module.exports = __webpack_public_path__ + "img/features-1-billing.1787f76a.png";